export default __webpack_public_path__ + "static/UNAC3-587d0af5c0ff3b24bcc212c8d912885c.png";